import { FeedHeader } from '@/features/feed/FeedHeader';
import { FeedItem } from '@/features/feed/FeedItem';
import React from 'react';
import { RightSidebar } from '@/features/feed/RightSidebar';
import AppLayout, { useLayout } from '@/layouts/AppLayout';

function Feed({ recognitions = [], auth, users = [], values = [] }) {
  const user = auth?.user;
  const { openGiveModal } = useLayout(); // Consume context from AppLayout

  const loading = false;

  return (
    <div className="h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 h-full">

        {/* LEFT COLUMN: Main Feed (8 cols) - Independent Scroll */}
        <div className="lg:col-span-8 h-full overflow-y-auto pr-2 scrollbar-hide">
          <FeedHeader openGiveModal={openGiveModal} user={user} />

          <h2 className="text-xl font-bold text-gray-800 mb-6 px-2 flex items-center gap-2 font-montserrat">
            <span>🌟</span> Reconocimientos bambú
          </h2>

          <div className="space-y-6 pb-20">
            {loading ? (
              <div className="flex justify-center py-10">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-bambu-green"></div>
              </div>
            ) : recognitions.length === 0 ? (
              <div className="text-center py-10 text-gray-400">
                <p>Aún no hay reconocimientos. ¡Sé el primero!</p>
              </div>
            ) : (
              recognitions.map(rec => (
                <FeedItem key={rec.id} recognition={rec} currentUser={user} users={users} companyValues={values} />
              ))
            )}
          </div>
        </div>

        {/* RIGHT COLUMN: Sidebar (4 cols) - Independent Scroll */}
        <div className="hidden lg:block lg:col-span-4 h-full overflow-y-auto pl-2 pb-20 scrollbar-hide">
          <RightSidebar />
        </div>

      </div>
    </div>
  );
}

Feed.layout = page => <AppLayout children={page} />;

export default Feed;
